import { trimToNull } from '~/utils/stringUtils';

export type BusinessAddress = {
  unit_number?: string | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  country?: string | null;
  formatted_address?: string | null;
};

export type BusinessDetailsForm = {
  abn?: string | null;
  businessName?: string | null;
  businessPosition?: string | null;
  businessAddress?: BusinessAddress | null;
};

export type BusinessDetailsApi = {
  abn?: string | null;
  business_name?: string | null;
  business_position?: string | null;
  business_address?: BusinessAddress | null;
  created_at?: string;
  updated_at?: string;
};

export function apiToFormBusinessDetails(apiResult?: BusinessDetailsApi | null): BusinessDetailsForm {
  if (!apiResult) {
    return {
      abn: null,
      businessName: null,
      businessPosition: null,
      businessAddress: null,
    };
  }

  return {
    abn: apiResult.abn ?? null,
    businessName: apiResult.business_name ?? null,
    businessPosition: apiResult.business_position ?? null,
    businessAddress: apiResult.business_address ?? null,
  };
}

export function formToApiBusinessDetails(form?: BusinessDetailsForm | null): BusinessDetailsApi {
  return {
    abn: trimToNull(form?.abn),
    business_name: trimToNull(form?.businessName),
    business_position: trimToNull(form?.businessPosition),
    business_address: form?.businessAddress ?? null,
  };
}
